




















































import { SearchLink } from '~/models/search/types'
import CCategoryIcon from '~/components/shared/configurable/category/CCategoryIcon.vue'
import { defineComponent, PropType, computed } from '~/utils/nuxt3-migration'
import { ciTrash } from '~/icons/source/thin/trash'
import { ciStar } from '~/icons/source/thin/star'
import { resolveCategory } from '~/utils/category'
import {
  categoriesIconsMappings,
  categoriesSolidIconsMappings
} from '~/constants/category/icon'
import { ciMagnifyingGlass } from '~/icons/source/thin/magnifying-glass'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'

export default defineComponent({
  components: { CExpandableContent, CCategoryIcon },
  props: {
    searchLinks: {
      type: Array as PropType<SearchLink[]>,
      required: true
    }
  },
  setup(props) {
    const { dispatch: classifiedSearchDispatch } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )

    const someLinkIsSelected = computed(() =>
      props.searchLinks.some(link => link.selected)
    )

    function getIcon(link: SearchLink) {
      if (link.type === 'deleted') {
        return ciTrash
      }

      if (link.type === 'promoted') {
        return ciStar
      }

      const iconsMappings = link.selected
        ? categoriesSolidIconsMappings
        : categoriesIconsMappings

      return (
        resolveCategory(iconsMappings, link.categoryIds) || ciMagnifyingGlass
      )
    }

    function getCountClass(link: SearchLink) {
      if (link.type === 'deleted') {
        return 'tw-bg-red-100 tw-text-red-400'
      }

      return link.selected
        ? 'tw-bg-blue-100 tw-text-blue-500'
        : 'tw-bg-grey-150 tw-text-grey-600 group-hover:tw-bg-blue-100 group-hover:tw-text-blue-500'
    }

    function getIconClasses(link: SearchLink) {
      if (link.type === 'deleted') {
        return 'tw-text-red-400'
      }

      return link.selected
        ? 'tw-text-blue-500'
        : 'tw-text-grey-600 group-hover:tw-text-blue-500'
    }

    function getLinkClasses(link: SearchLink) {
      if (link.type === 'deleted') {
        return 'tw-border-red-200 hover:tw-border-red-300 hover:tw-text-red-500'
      }

      return link.selected
        ? 'tw-border-blue-500 hover:tw-border-blue-500 hover:tw-text-blue-500 tw-bg-blue-50 tw-text-blue-500'
        : 'tw-border-grey-300 hover:tw-border-blue-500 hover:tw-text-blue-500'
    }

    function onClearButtonClick() {
      classifiedSearchDispatch('loadSeoUrlSearch', {
        seoUrl: '/classifieds/my/?category=20001&myclassifieds=1'
      })
    }

    function onLinkClick(link: SearchLink, e: Event) {
      if (link.selected) {
        e.preventDefault()
      }
      // classifiedSearchDispatch('loadSeoUrlSearch', { seoUrl: link.seoUrl })
    }

    return {
      someLinkIsSelected,
      getIcon,
      getCountClass,
      getIconClasses,
      getLinkClasses,
      onClearButtonClick,
      onLinkClick
    }
  },
  i18n: defineComponentTranslations({
    view_all_categories: {
      en: 'View all categories',
      el: 'Δες όλες τις κατηγορίες'
    }
  })
})
